import { render, staticRenderFns } from "./EddyCurrentViz.vue?vue&type=template&id=0cd84e46&scoped=true"
import script from "./EddyCurrentViz.vue?vue&type=script&lang=js"
export * from "./EddyCurrentViz.vue?vue&type=script&lang=js"
import style0 from "./EddyCurrentViz.vue?vue&type=style&index=0&id=0cd84e46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd84e46",
  null
  
)

export default component.exports